import type { HelpFile } from '../../types/help'
import { AccountStatusEventsTimelineTestIds } from '../../../testids/AccountStatusEventsTimelineTestIds'

export const accountStatusEventsTimelineHelp: HelpFile = {
  docPage: '/docs/admin/lifecycle-events',
  texts: {
    [AccountStatusEventsTimelineTestIds.accountStatusEventsTimeline]:
      'Vertikale Zeitleiste der Kontostatus-Ereignisse für dieses Konto — neueste zuerst. Jede Zeile zeigt das Statuspaar, die auslösende Quelle, den Akteur, den Zeitstempel und die Begründung.',
    [AccountStatusEventsTimelineTestIds.accountStatusFiltersPanel]:
      'Zeitleiste nach auslösender Quelle und Datumsbereich filtern. Filter sind standardmäßig eingeklappt — auf "Filter" klicken zum Ausklappen.',
    [AccountStatusEventsTimelineTestIds.accountStatusTimelineEmpty]:
      'Keine Kontostatus-Ereignisse entsprechen den aktuellen Filtern. Über "Filter zurücksetzen" alle Filter aufheben oder neue Übergänge abwarten.',
    [AccountStatusEventsTimelineTestIds.accountStatusTimelineError]:
      'Die Zeitleiste konnte nicht geladen werden. Details im Fehlerprotokoll prüfen und erneut versuchen.',
    [AccountStatusEventsTimelineTestIds.accountStatusTimelineLoading]: null,
    [AccountStatusEventsTimelineTestIds.accountStatusTimelineRows]:
      'Kontostatus-Ereigniszeilen — jede Zeile verlinkt auf die auslösende Referenz (Job-Ausführung, Zugriffsanfrage oder ursprüngliches Identitätsereignis).',
    [AccountStatusEventsTimelineTestIds.accountStatusEventTriggerRefLink]:
      'Direktlink zum Auslöser dieser Statusänderung — öffnet die zugehörige Job-Ausführung oder Zugriffsanfrage.',
    [AccountStatusEventsTimelineTestIds.btnToggleAccountStatusFilters]:
      'Filterpanel dieser Zeitleiste ein- oder ausblenden.',
    [AccountStatusEventsTimelineTestIds.btnClearAccountStatusFilters]:
      'Alle Filter dieser Zeitleiste zurücksetzen.',
    [AccountStatusEventsTimelineTestIds.inputAccountStatusFilterFrom]:
      'Untere Grenze des Datumsbereichs — Ereignisse mit einem changed_at davor werden ausgeblendet.',
    [AccountStatusEventsTimelineTestIds.inputAccountStatusFilterTo]:
      'Obere Grenze des Datumsbereichs — Ereignisse mit einem changed_at danach werden ausgeblendet.',
  },
}
